import React from 'react'
import { InputNumber } from 'primereact/inputnumber'

class InputsImpostosRetidosComponent extends React.Component {

    state = {

    }


    render(){

        const renderValor = (label, name, valor, disabled, shouldStyle) => {
            return(
                <>
                <div
                    className='col-md'
                    style={shouldStyle ? {
                        // marginLeft: '5em',
                        // maxWidth: '120px'
                    } : {}}
                >
                    <label style={{ display: 'block' }}>{label}</label>
                    <InputNumber
                        inputStyle={shouldStyle ? { width: '7.5rem' } : {}}
                        name={name}
                        onValueChange={this.props.handleChange}
                        value={valor}
                        mode="decimal" locale="pt-BR" minFractionDigits={2}
                        disabled={disabled}
                    />
                </div>
                </>
            )
        }

        return (
            <>

                {renderValor("Valor Bruto", "valorBruto", this.props.valorBruto, this.props.disabled, !this.props.disabled)}
                {renderValor("Valor PIS", "impostoRetidoValorPIS", this.props.valorPis, this.props.disabled, !this.props.disabled)}
                {renderValor("Valor COFINS", "impostoRetidoValorCOFINS", this.props.valorCofins, this.props.disabled, !this.props.disabled)}
                {renderValor("Valor INSS", "impostoRetidoValorINSS", this.props.valorInss, this.props.disabled, !this.props.disabled)}
                {renderValor("Valor IR", "impostoRetidoValorIR", this.props.valorIr, this.props.disabled, !this.props.disabled)}
                {renderValor("Valor CSLL", "impostoRetidoValorCSLL", this.props.valorCsll, this.props.disabled, !this.props.disabled)}
                {renderValor("Valor ISS", "impostoRetidoValorISS", this.props.valorIss, this.props.disabled, !this.props.disabled)}
                {renderValor("Valor Líquido", "valorLiquido", this.props.valorLiquido, true, !this.props.disabled)}

            </>
        )

    }


}

export default InputsImpostosRetidosComponent